var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" PART_5 "),_c('saveButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }